import React from 'react';
import { SectionHeader } from '../components/SectionHeader';
import { DetailReadOnlyField } from '../components/DetailFields';
import { detailGrid2 } from '../storeDetailsConstants';
import { formatCurrency, formatPercent, titleCase } from '../storeDetailsUtils';

export function MerchantPackageSection({ meta, store }) {
  const pkg = store?.kitchen_operation?.merchant_package ?? {};

  return (
    <>
      <SectionHeader Icon={meta.Icon} title={meta.title} subtitle={meta.subtitle} />

      <div style={detailGrid2}>
        <DetailReadOnlyField label="Package plan" value={titleCase(pkg.package_plan)} />
        <DetailReadOnlyField label="Agreement policy no." value={pkg.agreement_policy_no} />
        <DetailReadOnlyField
          label="Regular menu processing fee"
          value={formatPercent(pkg.regularMenu_processing_fee_percentage)}
        />
        <DetailReadOnlyField
          label="Subscription menu processing fee"
          value={formatPercent(pkg.subscriptionMenu_processing_fee_percentage)}
        />
        <DetailReadOnlyField
          label="Regular menu pickup processing fee"
          value={formatPercent(pkg.regularMenu_pickup_order_processing_fee_percentage)}
        />
        <DetailReadOnlyField
          label="Transaction card fee"
          value={formatPercent(pkg.transaction_card_fee_percentage)}
        />
        <DetailReadOnlyField
          label="Transaction card fixed amount"
          value={formatCurrency(pkg.transaction_card_fixed_amount)}
        />
        <DetailReadOnlyField
          label="Invited customer regular menu fee"
          value={formatPercent(pkg.invited_customer_regularMenu_processing_fee_percentage)}
        />
      </div>
    </>
  );
}
